"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpRequestClose;
(function (HttpRequestClose) {
    HttpRequestClose["Load"] = "load";
    HttpRequestClose["Abort"] = "abort";
    HttpRequestClose["Error"] = "error";
    HttpRequestClose["Timeout"] = "timeout";
})(HttpRequestClose || (HttpRequestClose = {}));
exports.default = HttpRequestClose;
//# sourceMappingURL=HttpRequestClose.js.map